const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_CREW':
      return action.crew;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/crew.js